import PropTypes from "prop-types";

function PrevArrow(props) {
  const { className, customClassName, style, onClick } = props;
  return (
    <div className={`${className} ${customClassName}`} style={{ ...style }} onClick={onClick} />
  );
}

export default PrevArrow;

PrevArrow.propTypes = {
  className: PropTypes.string,
  customClassName: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
};
